import { CheckCircle2, Loader2, AlertTriangle, Clock, Ban } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { type DocumentIndexStatusT } from '@toga/shared'

interface Props {
  status: DocumentIndexStatusT
  error?: string | null
  className?: string
}

const STYLES: Record<
  DocumentIndexStatusT,
  { bg: string; text: string; border: string; icon: typeof CheckCircle2 }
> = {
  PENDING: {
    bg: 'bg-slate-500/15',
    text: 'text-slate-600 dark:text-slate-300',
    border: 'border-slate-500/30',
    icon: Clock,
  },
  PROCESSING: {
    bg: 'bg-blue-500/15',
    text: 'text-blue-700 dark:text-blue-300',
    border: 'border-blue-500/40',
    icon: Loader2,
  },
  DONE: {
    bg: 'bg-emerald-500/15',
    text: 'text-emerald-700 dark:text-emerald-300',
    border: 'border-emerald-500/40',
    icon: CheckCircle2,
  },
  FAILED: {
    bg: 'bg-rose-500/15',
    text: 'text-rose-700 dark:text-rose-300',
    border: 'border-rose-500/30',
    icon: AlertTriangle,
  },
  SKIPPED: {
    bg: 'bg-amber-500/10',
    text: 'text-amber-700 dark:text-amber-300',
    border: 'border-amber-500/40',
    icon: Ban,
  },
}

export default function DocIndexBadge({ status, error, className }: Props) {
  const { t } = useTranslation()
  const s = STYLES[status]
  const Icon = s.icon
  return (
    <span
      className={[
        'inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] border',
        s.bg,
        s.text,
        s.border,
        className ?? '',
      ].join(' ')}
      title={error ?? t('enums:DocumentIndexStatus.' + status)}
    >
      <Icon size={10} className={status === 'PROCESSING' ? 'animate-spin' : ''} />
      {t('enums:DocumentIndexStatus.' + status)}
    </span>
  )
}
